import styles from './mobileOffcanvas.module.css';
import MobileNavbar from "../mobileNavbar/MobileNavbar";
import { Offcanvas } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { CiSearch } from 'react-icons/ci';
import { memo, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../../contexts/Appcontext';

const MobileOffcanvas = memo(({ show, close, handleSearch }) => {

  const { siteInfos } = useContext(AppContext);
  const [searchContent, setSearchContent] = useState('');

  return (
    <div className='position-relative'>
      <Offcanvas className={`${styles.offcanvas} bg-dark text-light`} show={show} placement="end">
        <Offcanvas.Header className='d-flex justify-content-between align-items-center'>
          <Offcanvas.Title>
            <Link to='/' className='d-flex align-items-center gap-2 ms-3'>
              <img className={styles.logo} src="/assets/images/logo/logo.png" alt={siteInfos.webname} />
              <div className='d-flex flex-column justify-content-between '>
                <strong className={`${styles.title} h2`}>{siteInfos.webname}</strong>
                <p className={styles.description}>آزمایشکاهی، تحقیقاتی، سلولی و مولکولی</p>
              </div>
            </Link>
          </Offcanvas.Title>
          <IoClose className={styles.closeButton} onClick={close} />
        </Offcanvas.Header>
        <Offcanvas.Body >

          <div className={`${styles.mobileSearch_container} d-flex align-items-center px-2 border border-secondary rounded-pill mb-2`}>
            <input className={styles.mobileSearch} type='search' placeholder="جستجوی محصولات ..." value={searchContent}
              onChange={(event) => setSearchContent(event.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchContent);
                  close();
                }
              }} />
            <CiSearch className={styles.mobileSearchIcon} onClick={() => {
              handleSearch(searchContent);
              close();
            }} />
          </div>

          <MobileNavbar />

          <strong className={`${styles.developers} bg-dark text-secondary`}>
            <a href='https://www.metavia.ir/' rel='noreferrer noopener' target='_blank'>طراحی و توسعه: Metavia</a>
          </strong>

        </Offcanvas.Body>
      </Offcanvas>
    </div>
  )
});

export default MobileOffcanvas;
